import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, withKeys as _withKeys, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d532e9ae")

_pushScopeId("data-v-d532e9ae")
const _hoisted_1 = { class: "waybill" }
const _hoisted_2 = { class: "control-bar" }
const _hoisted_3 = { class: "search-wrap" }
const _hoisted_4 = { class: "table" }
const _hoisted_5 = {
  key: 0,
  class: "flex"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "注册状态", -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "flex"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("-")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PageHeader = _resolveComponent("PageHeader")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_Tags = _resolveComponent("Tags")
  const _component_TextTip = _resolveComponent("TextTip")
  const _component_Table = _resolveComponent("Table")
  const _component_WaybillDetail = _resolveComponent("WaybillDetail")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("header", null, [
      _createVNode(_component_PageHeader, { title: "运单号列表" })
    ]),
    _createVNode("main", null, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.status,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.status = $event)),
            size: "small",
            style: {"width":"120px","margin-right":"16px"},
            onChange: _ctx.search
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.statusTypes, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"]),
          _createVNode(_component_el_input, {
            placeholder: "请输入订单编号或物流单号",
            modelValue: _ctx.keyword,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.keyword = $event)),
            class: "input-with-select",
            size: "small",
            style: {"width":"350px"},
            onKeyup: _withKeys(_ctx.search, ["enter"])
          }, {
            append: _withId(() => [
              _createVNode(_component_el_button, {
                size: "medium",
                icon: "el-icon-search",
                onClick: _ctx.search
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["modelValue", "onKeyup"])
        ])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_Table, {
          data: _ctx.tableList,
          loading: _ctx.loading,
          pagination: _ctx.pagination,
          onCurrentChange: _ctx.pageChange
        }, {
          default: _withId(() => [
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "80"
            }, {
              default: _withId(({ row }) => [
                (row.register_status == 30)
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _createVNode(_component_el_tooltip, {
                        content: "推送",
                        placement: "top"
                      }, {
                        default: _withId(() => [
                          _createVNode("img", {
                            src: _ctx.push,
                            alt: "",
                            onClick: ($event: any) => (_ctx.handlePush(row))
                          }, null, 8, ["src", "onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "订单编号",
              prop: "order_number"
            }),
            _createVNode(_component_el_table_column, {
              label: "承运商",
              width: "180"
            }, {
              default: _withId(({ row }) => [
                (row.register_status == 30)
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode(_component_el_select, {
                        modelValue: row.courier_code,
                        "onUpdate:modelValue": ($event: any) => (row.courier_code = $event),
                        filterable: "",
                        "remote-method": _ctx.courierFilter,
                        onChange: ($event: any) => (_ctx.updateCarrierSelect(row)),
                        size: "small"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.carrierOptions, (carrierItem) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: carrierItem.id,
                              label: carrierItem.courier_name,
                              value: carrierItem.courier_code
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "remote-method", "onChange"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(row.courier_name), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "物流单号",
              prop: "tracking_number"
            }),
            _createVNode(_component_el_table_column, {
              label: "注册状态",
              width: "130"
            }, {
              header: _withId(() => [
                _createVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_el_tooltip, {
                    content: "系统每分钟会自动检测将未注册的物流单号同步至物流平台进行注册查询",
                    placement: "top"
                  }, {
                    default: _withId(() => [
                      _createVNode("img", {
                        src: _ctx.hint,
                        alt: ""
                      }, null, 8, ["src"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              default: _withId(({ row }) => [
                (row.register_status != 30)
                  ? (_openBlock(), _createBlock("div", _hoisted_10, [
                      _createVNode(_component_Tags, {
                        text: row.register_status == 10 ? '未注册' : '注册成功',
                        type: row.register_status == 10 ? 'init' : 'success'
                      }, null, 8, ["text", "type"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_11, [
                      _createVNode(_component_Tags, {
                        text: "注册失败",
                        type: "danger",
                        style: {"margin-right":"5px"}
                      }),
                      _createVNode(_component_el_tooltip, {
                        content: row.register_failed_message,
                        placement: "top"
                      }, {
                        default: _withId(() => [
                          _createVNode("img", {
                            src: _ctx.hint,
                            alt: ""
                          }, null, 8, ["src"])
                        ]),
                        _: 2
                      }, 1032, ["content"])
                    ]))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "物流状态" }, {
              default: _withId(({ row }) => [
                _createVNode("span", null, _toDisplayString(row.delivery_status || '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "运输时长" }, {
              default: _withId(({ row }) => [
                _createVNode("span", null, _toDisplayString(Number(row.days_of_transit) ? `${row.days_of_transit}天` : '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "妥投时效" }, {
              default: _withId(({ row }) => [
                _createVNode("span", null, _toDisplayString(Number(row.days_of_transit_done) ? `${row.days_of_transit_done}天` : '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "物流信息",
              width: "220"
            }, {
              default: _withId(({ row }) => [
                (row.last_shipping_detail)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createVNode("div", null, _toDisplayString(row.last_tracked_at || '-'), 1),
                      _createVNode(_component_TextTip, {
                        content: row.last_shipping_detail,
                        style: {"max-width":"100%","color":"#333"}
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(row.last_shipping_detail), 1)
                        ]),
                        _: 2
                      }, 1032, ["content"]),
                      (row.last_shipping_detail !== '')
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: "see_delivery",
                            onClick: ($event: any) => (_ctx.see_info(row))
                          }, " 查看详情 ", 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_12
                    ], 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "loading", "pagination", "onCurrentChange"])
      ])
    ]),
    _createVNode(_component_WaybillDetail, {
      "is-visibil": _ctx.isShowInfo,
      "order-info": _ctx.orderInfo,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowInfo = false))
    }, null, 8, ["is-visibil", "order-info"])
  ]))
})